import AbstractEnumSelect from "../AbstractEnumSelect";

const CompanyTypeSelect = ({customOnChange, companyTypes, allowMultiple, disabled, value, onChange, loading}) => {

    return <AbstractEnumSelect
        onChange={customOnChange}
        enums={companyTypes}
        enumName="Type d'organisation"
        allowMultiple={allowMultiple}
        disabled={disabled}
        antValue={value}
        antOnChange={onChange}
        loading={loading}
    />;
}

export default CompanyTypeSelect;
